export const EventStatus = Object.freeze({ PENDING: 'PENDING', ADMITTED: 'ADMITTED', REJECTED: 'REJECTED' });
export const CommitClass = Object.freeze({ NONE: 'NONE', ASSOCIATIVE: 'ASSOCIATIVE', CANONICAL: 'CANONICAL' });
export const PromotionStatus = Object.freeze({
  NOT_REQUESTED: 'NOT_REQUESTED', REQUESTED: 'REQUESTED', PREDICATES_FAILED: 'PREDICATES_FAILED',
  PREDICATES_SATISFIED: 'PREDICATES_SATISFIED', AWAITING_GOVERNANCE: 'AWAITING_GOVERNANCE',
  UNDER_REVIEW: 'UNDER_REVIEW', DENIED: 'DENIED', QUARANTINED: 'QUARANTINED',
  AUTHORIZED: 'AUTHORIZED', COMMITTED: 'COMMITTED'
});
export const RegimeStatus = Object.freeze({ STABLE: 'STABLE', UNSTABLE: 'UNSTABLE', STABILIZING: 'STABILIZING' });
export const GovernanceDecisionValue = Object.freeze({ ALLOW: 'ALLOW', REVIEW: 'REVIEW', DENY: 'DENY', QUARANTINE: 'QUARANTINE' });
export const EvidenceDimension = Object.freeze({
  DIRECT_ASSERTION: 'DIRECT_ASSERTION', OBSERVED_BEHAVIOR: 'OBSERVED_BEHAVIOR', TEMPORAL_PERSISTENCE: 'TEMPORAL_PERSISTENCE',
  CONTEXTUAL_CONSISTENCY: 'CONTEXTUAL_CONSISTENCY', INDEPENDENT_CORROBORATION: 'INDEPENDENT_CORROBORATION',
  CORRECTIVE_CONFIRMATION: 'CORRECTIVE_CONFIRMATION'
});
